import React from "react";
import PropTypes from "prop-types";
import getClassNameFactory from "@emcm-ui/utility-class-names";

const getPath = (name, props) => {
  switch (name) {
    case "close":
      return (
        <path
          {...props}
          d="M27.5861028,3.00085283 L28.9982943,4.41304438 L17.414,15.997 L29.0032453,27.5861028 L27.5890317,29.0003163 L16,17.411 L4.41219155,28.9991472 L3,27.5869556 L14.587,15.999 L3.00292893,4.41421356 L4.41714249,3 L16.002,14.585 L27.5861028,3.00085283 Z"
        />
      );
    case "search":
      return (
        <path
          {...props}
          d="M13.9585481,2 C20.5630719,2 25.9170963,7.35402437 25.9170963,13.9585481 C25.9170963,16.8301187 24.7686012,19.6049993 23.0816215,21.6664982 L29.8994949,28.4852814 L28.4852814,29.8994949 L21.6640371,23.0753342 C19.6025381,24.7623139 16.8301187,25.9170963 13.9585481,25.9170963 C7.35402437,25.9170963 2,20.5630719 2,13.9585481 C2,7.35402437 7.35402437,2 13.9585481,2 Z M14,4 C8.4771525,4 4,8.4771525 4,14 C4,19.5228475 8.4771525,24 14,24 C19.5228475,24 24,19.5228475 24,14 C24,8.4771525 19.5228475,4 14,4 Z"
        />
      );
    case "success":
      return (
        <path
          {...props}
          d="M16,2 C23.7319865,2 30,8.2680135 30,16 C30,23.7319865 23.7319865,30 16,30 C8.2680135,30 2,23.7319865 2,16 C2,8.2680135 8.2680135,2 16,2 Z M16,4 C9.372583,4 4,9.372583 4,16 C4,22.627417 9.372583,28 16,28 C22.627417,28 28,22.627417 28,16 C28,9.372583 22.627417,4 16,4 Z M22.4852814,10.35 L23.8994949,11.7642136 L14,21.6637085 L12.5857864,20.2494949 L12.589,20.245 L8,15.6568542 L9.41421356,14.2426407 L14.003,18.831 L22.4852814,10.35 Z"
        />
      );
    case "error":
      return (
        <path
          {...props}
          d="M16,2 C23.7319865,2 30,8.2680135 30,16 C30,23.7319865 23.7319865,30 16,30 C8.2680135,30 2,23.7319865 2,16 C2,8.2680135 8.2680135,2 16,2 Z M16,4 C9.372583,4 4,9.372583 4,16 C4,22.627417 9.372583,28 16,28 C22.627417,28 28,22.627417 28,16 C28,9.372583 22.627417,4 16,4 Z M15,8 L17,8 L17,19 L15,19 L15,8 Z M16,24 C16.5522847,24 17,23.5522847 17,23 C17,22.4477153 16.5522847,22 16,22 C15.4477153,22 15,22.4477153 15,23 C15,23.5522847 15.4477153,24 16,24 Z"
        />
      );
    case "information-07":
      return (
        <path
          {...props}
          d="M16,2 C23.7319865,2 30,8.2680135 30,16 C30,23.7319865 23.7319865,30 16,30 C8.2680135,30 2,23.7319865 2,16 C2,8.2680135 8.2680135,2 16,2 Z M16,4 C9.372583,4 4,9.372583 4,16 C4,22.627417 9.372583,28 16,28 C22.627417,28 28,22.627417 28,16 C28,9.372583 22.627417,4 16,4 Z M16,10 C16.5522847,10 17,9.55228475 17,9 C17,8.44771525 16.5522847,8 16,8 C15.4477153,8 15,8.44771525 15,9 C15,9.55228475 15.4477153,10 16,10 Z M15,13 L17,13 L17,24 L15,24 L15,13 Z"
        />
      );
    case "download-07":
      return (
        <path
          {...props}
          d="M4,17 L4,25 L28,25 L28,17 L30,17 L30,27 L2,27 L2,17 L4,17 Z M17.0038077,5 L17.0038077,17.5952911 L22.3581746,12.25 L23.7723882,13.6642136 L16,21.4423882 L8.22,13.6642136 L9.63421356,12.25 L14.9994935,17.6169739 L14.9994935,5 L17.0038077,5 Z"
        />
      );
    case "caret":
      return (
        <path
          {...props}
          d="M17.037 16.745l5.508-5.345L24 12.814l-7.996 7.778L8 12.814 9.455 11.4l5.52 5.367 1.025.994z"
        />
      );
    case "menu":
      return (
        <path
          {...props}
          d="M2,24 L2,22 L30,22 L30,24 L2,24 Z M2,17 L2,15 L30,15 L30,17 L2,17 Z M2,10 L2,8 L30,8 L30,10 L2,10 Z"
        />
      );
    case "share":
      return (
        <path
          {...props}
          d="M23.64,2.65 L28.99,8 L29,8 L29,8.01 L30.003961,9.01396103 L23.64,15.3779221 L22.2257864,13.9637085 L26.1885073,10.0009876 L13.5,10 C7.8,10 4,14.8 4,19.5 L4,30 L2,30 L2,19.5 C2,13.1 7.1,8 13.5,8 L26.163,8 L22.2263284,4.06367159 L23.64,2.65 Z"
        />
      );
    case "arrow":
      return (
        <path
          {...props}
          d="M17.001 24.154l5.545-5.345 1.455 1.414-7.996 7.778-8.004-7.778 1.455-1.414 5.545 5.367V3.999h2z"
        />
      );
    case "fullscreen":
      return (
        <path
          {...props}
          d="M5.396 4L13 11.582 11.583 13 4 5.4V11H2V2h9v2H5.396zm21.208 0L19 11.582 20.417 13 28 5.4V11H30V2h-9v2h5.604zM5.396 28L13 20.418 11.583 19 4 26.6V21H2v9h9v-2H5.396zm21.208 0L19 20.418 20.417 19 28 26.6V21H30v9h-9v-2h5.604z"
        />
      );
    case "playtriangle":
      return <path {...props} d="M29 16 3 30 3 2" />;
    case "filter":
      return (
        <path {...props} d="M12 24v-2h8v2h-8zm-5-7v-2h18v2H7zm-5-7V8h28v2H2z" />
      );
    case "download":
      return (
        <path
          {...props}
          d="M4,17 L4,25 L28,25 L28,17 L30,17 L30,27 L2,27 L2,17 L4,17 Z M17.0038077,5 L17.0038077,17.5952911 L22.3581746,12.25 L23.7723882,13.6642136 L16,21.4423882 L8.22,13.6642136 L9.63421356,12.25 L14.9994935,17.6169739 L14.9994935,5 L17.0038077,5 Z"
        />
      );
    case "cart":
      return (
        <path
          {...props}
          d="M7.45 3l1.34 5.01h18.89a2 2 0 011.93 2.52l-2.68 9.99A2 2 0 0125 22H12a2 2 0 01-1.92-1.44L5.93 5H3.17C2.58 5 2 4.59 2 4c0-.59.58-1 1.17-1h4.28zm20.23 7H9.32L12 20h13l2.68-10zM12 24a3 3 0 110 6 3 3 0 010-6zm0 2a1 1 0 100 2 1 1 0 000-2zm14-2a3 3 0 110 6 3 3 0 010-6zm0 2a1 1 0 100 2 1 1 0 000-2z"
        />
      );
    case "user":
      return (
        <path
          {...props}
          d="M16,2 C23.7319865,2 30,8.2680135 30,16 C30,23.7319865 23.7319865,30 16,30 C8.2680135,30 2,23.7319865 2,16 C2,8.2680135 8.2680135,2 16,2 Z M16,17 C14.2410909,17 12.493,17.394 11.3360909,17.7246667 C9.96090909,18.1173333 9,19.4393333 9,20.9386667 L9,20.9386667 L9,21.9090909 C9,22.5090909 9.48461538,23 10.0769231,23 L10.0769231,23 L21.9230769,23 C22.5153846,23 23,22.5090909 23,21.9090909 L23,21.9090909 L23,20.9386667 C23,19.4393333 22.0390909,18.118 20.6639091,17.7246667 C19.507,17.394 17.7582727,17 16,17 Z M15.875,7 C13.94475,7 12.375,8.656 12.375,10.6923077 L12.375,10.6923077 L12.375,11.3076923 C12.375,13.344 13.94475,15 15.875,15 C17.80525,15 19.375,13.344 19.375,11.3076923 L19.375,11.3076923 L19.375,10.6923077 C19.375,8.656 17.80525,7 15.875,7 Z"
        />
      );
    default:
      return <path />;
  }
};

export const SVGIcon = ({
  name = "",
  style = {},
  fill = "",
  viewBox = "0 0 32 32",
  size = "xs",
  icon,
  getExternalIconPath
}) => {
  const getClassName = getClassNameFactory("Icon");

  return (
    <svg
      style={style}
      className={getClassName({ modifiers: size })}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      {icon}
      {getExternalIconPath
        ? getExternalIconPath(name, { fill })
        : getPath(name, { fill })}
    </svg>
  );
};

SVGIcon.displayName = "Icon";

/* eslint-disable max-len */
SVGIcon.propTypes = {
  /**
   * Name of the icon
   */
  name: PropTypes.string,
  /**
   * Custom style object
   */
  style: PropTypes.object,
  /**
   * Default fill color
   */
  fill: PropTypes.string,
  /**
   * viewBox for icon
   */
  viewBox: PropTypes.string,
  /**
   * Icon size in [s,xs,m,l]
   */
  size: PropTypes.string,
  /**
   * This is used to pass external icon path config
   */
  getExternalIconPath: PropTypes.func,
  /**
   * Pass single Icon path
   */
  icon: PropTypes.node
};
/* eslint-enable max-len */
